import React from "react";
import { Link, Redirect } from "react-router-dom";
import { Box, Button, FormControl, Input, InputLabel, Typography } from "@material-ui/core";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { CSSProperties } from "@material-ui/styles";
import clsx from "clsx";
import { isLogin } from "src/app-redux/auth/authSlice";
import { useAppSelector } from "src/app-redux/hooks";
import NJSLogo from "src/assets/images/tfg_mainlogo.svg";

const mediumText: CSSProperties = {
  fontWeight: 500,
} as const;
const semiBoldText: CSSProperties = {
  fontWeight: 600,
} as const;

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      display: "flex",
      flexWrap: "wrap",
    },
    loginButton: {
      backgroundColor: "#72CA00 !important",
      color: "#ffffff",
      width: "100%",
      marginTop: "80px",
      fontSize: "12px",
      textTransform: "unset",
      boxShadow: "none",
    },
    textFieldsRow: {
      margin: "5px 0 20px",
      boxShadow: "0px 1px 2px 0px rgba(0,0,0,6%)",
    },
    textInput: {
      height: "32px",
      padding: "0 8px",
      color: "#292929",
      fontSize: "12px",
      border: "1px solid #E6E6E6",
      borderRadius: "4px",
      letterSpacing: "0.16px",
      "&:placeholder": {
        color: "#A3A3A3",
      },
    },
    inputLabel: {
      padding: "0 0 10px",
      color: "#292929",
      fontSize: "12px",
      letterSpacing: "0.16px",
    },
    footNote: {
      fontSize: "12px",
      color: "#96A4B9",
      margin: "auto",
      display: "block",
      maxWidth: "320px",
    },
    headNote: {
      display: "block",
      margin: "25px 0",
      fontSize: "12px",
      color: "#292929",
    },
    headerWrap: {
      display: "flex",
      alignItems: "center",
    },
    backButton: {
      minWidth: "45px",
      marginLeft: "-45px",
      padding: "0",
      justifyContent: "start",
      backgroundColor: "transparent !important",
    },
    headerLogo: {
      textAlign: "center",
    },
    headerLogoLink: {
      textAlign: "center",
      width: "100%",
      float: "left",
    },
  })
);
export function ForgotPassword() {
  const classes = useStyles();
  const user = useAppSelector(isLogin);

  return user ? (
    <Redirect to={{ pathname: "/" }} />
  ) : (
    <div className="forgot-password-page">
      <div className="left-section">
        <div className="inner">
          <Box my={2} className="headerLogo" textAlign="Center">
            <a href="/" className="headerLogoLink">
              <img src={NJSLogo} alt="logo" width="200" />
            </a>
          </Box>
          <div className="form-wrapper">
            <div className={clsx(classes.headerWrap)}>
              <Button component={Link} to="/auth/login" className={clsx(classes.backButton)}>
                <ArrowBackIcon></ArrowBackIcon>
              </Button>
              <h2 className="form-heading">Forgot your password?</h2>
            </div>
            <Typography
              component="span"
              variant="body1"
              color="textPrimary"
              style={semiBoldText}
              className={clsx(classes.headNote)}
            >
              Enter your email address and we&apos;ll send you a link to get back into your account
            </Typography>
            <InputLabel className={clsx(classes.inputLabel)} htmlFor="my-input" style={mediumText}>
              Email address
            </InputLabel>
            <FormControl className={`MuiFormControl-fullWidth ${clsx(classes.textFieldsRow)}`}>
              <Input
                placeholder="myemail@address.com"
                className={clsx(classes.textInput)}
                disableUnderline={true}
                style={mediumText}
              />
            </FormControl>
            <Button variant="contained" className={clsx(classes.loginButton)} style={semiBoldText}>
              Send Log in Link
            </Button>
          </div>
          <Typography
            component="span"
            variant="body1"
            color="textPrimary"
            style={mediumText}
            className={clsx(classes.footNote)}
          >
            Copyright©, NLC, {new Date().getFullYear()}
          </Typography>
        </div>
      </div>
      <div className="right-section">
        <div className="login-bg-pattern"></div>
      </div>
    </div>
  );
}
